import {useEffect, useState} from "react";
import {getPreviewApi} from "../api/api";

export const useFile = ({fileId}) => {

    const [file, setFile] = useState(null)

    useEffect(() => {

        if (!!fileId) {
            getPreviewApi(fileId).then(previewRes => {
                setFile(previewRes)
            })
        }
    }, [fileId])

    return [file]
}